export enum TransitionPhase {
  None = "none",
  Out = "out",
  In = "in",
  Change = "change",
}

export enum AnimationType {
  Slide = "slide",
}

export enum SlideDirection {
  Left = "left",
  Right = "right",
  Up = "up",
  Down = "down",
}

export enum SlidePhase {
  In = "in",
  Out = "out",
}

export enum TypeMode {
  In = "in",
  Out = "out",
}

export enum BlinkMode {
  Row = "row",
  UpdateCol = "update",
}
